import { emptyFn } from 'utils/function';

import {
  createTaskOption,
  TaskOption,
  TaskOptionConfig,
  TaskOptionParams,
} from './createTaskOptions';
import { pick } from 'utils/object';

const optionsCache: Record<string, TaskOptionConfig & { option: TaskOption }> = {};

export function registerTaskOption(params: TaskOptionParams) {
  const option = params.modal ?? params.action;

  if (optionsCache[option]) throw new Error(`Duplicate task option registered ${option}`);

  optionsCache[option] = {
    ...createTaskOption(params),
    option,
  };
}

export function getTaskOptionConfig(option: TaskOption) {
  const config = optionsCache[option];

  if (!config) throw new Error(`Config for task option ${option} not found`);

  return config;
}

export function useTaskOption(option: TaskOption, taskId: string) {
  const config = getTaskOptionConfig(option);

  const { action, ...options } = config.useTaskAction(taskId);

  return {
    ...pick(config, ['Icon', 'overlay', 'shortcutKey']),
    ...options,
    action: options.isEnabled ? action : emptyFn,
    getLabel: options.getLabel ?? config.getLabel,
  };
}

export function getTaskOptions() {
  const keys: string[] = [];

  Object.values(optionsCache).forEach(({ shortcutKey }) => {
    if (!shortcutKey) return;

    if (keys.includes(shortcutKey))
      throw new Error(`Shortcut key for task option already in use ${shortcutKey}`);

    keys.push(shortcutKey);
  });

  return optionsCache as Record<TaskOption, TaskOptionConfig & { option: TaskOption }>;
}
